import { render, staticRenderFns } from "./AddPurchase.vue?vue&type=template&id=3dee20f7&scoped=true&"
import script from "./AddPurchase.vue?vue&type=script&lang=js&"
export * from "./AddPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchase.vue?vue&type=style&index=0&id=3dee20f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee20f7",
  null
  
)

export default component.exports